'use strict';

var GridColumnCustomizationButtonDirective = function GridColumnCustomizationButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-column-customization-button.html')
  };
};
GridColumnCustomizationButtonDirective.$inject = [];
module.exports = GridColumnCustomizationButtonDirective;